import React from 'react';
import styled from "styled-components";
import Section from "./Section"


function Home() {
  return (
    <Container>
        <Section 
         title="Welcome to Krungtepian Website" 
         description="created by Nutthaweed"
         backgroundImg="20220203_103617.jpg"
         leftBtnText="About Server"
         rightBtnText="About us"
        />
        <Section 
        title="About Server"
        description="Krungtepian is discord server community that you can chitchat all along with your friends and everyone.
        you can enjoy everything about it"
        backgroundImg="20220208_125816.jpg"
        rightBtnText="Back"
        />
        <Section 
        title="About Us"
        description="Facebook: Nutthaweed, Instragram: @nutthaweed,here my website: https://kcross-6p24cy8rw-nutthaweed.vercel.app/"
        backgroundImg="20220208_134854.jpg"
        rightBtnText="Back"
        />
        
    </Container>
  );
}

export default Home;

const Container = styled.div`
้  height: 100vh;
`
